import { Grid } from "@mui/material";
import React, { useState } from "react"
import WSButton from "../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";


export const UserList: React.FC<any> = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { showMessage } = useSnackbar();
  const filters = ["All Records"];

  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const source = {
    url: "Vyapar/User/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  const handleClick = () => {
    navigate('/add-user')
  }

  const handleAction = (action: string, row: { customerName: string, id: number }) => {
    console.log("Row data:", row);

    if (action === "Edit") {
      navigate(`/user/edit/${row.id}`);
    } else if (action === "Delete") {
      setSelectedId(row.id);
      setPopupOpen(true);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "userName",
    },

    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction,
    },
  ];

  
  return (
    <>
      <Grid p={3}>
        <Grid container spacing={2}>

          <Grid item xs={12}>

            <WSDataGrid
              id="userGrid"
              title="User"
              columns={columns}
              source={source}
              searchBox={{ fieldName: "specializations" }}
              addButton={{ label: "Add User", color: "secondary" }}
              onAddButtonClick={handleClick}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          </Grid>
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/User"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this user?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            console.log("Delete response:", data);
            dispatch(resetDataComponent("userGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message, "error");
            }
          }}
        />
      </Grid>
    </>
  )
})